import { render } from "./PromoSearchForm.vue?vue&type=template&id=f588a02a&scoped=true"
import script from "./PromoSearchForm.vue?vue&type=script&lang=js"
export * from "./PromoSearchForm.vue?vue&type=script&lang=js"

import "./PromoSearchForm.vue?vue&type=style&index=0&id=f588a02a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f588a02a"]])

export default __exports__